export function getTotalOfQuestionsOfForm(form: FormUntouched): number {
  return form.surveys.reduce<number>((acc: number, survey) => {
    return (acc += survey.questions.length)
  }, 0)
}
